<template>
  <div>
    <v-select
      :items="items"
      :label="label"
      v-model="permission.permissionValue"
      @change="updatePermission"
      :loading="loading"
    ></v-select>
  </div>
</template>

<script>
export default {
  name: 'ChildPermission',
  data() {
    return {
      items: [
        { text: 'Allow photos', value: '1' },
        { text: `Don't allow photos`, value: '0' },
      ],
      loading: false,
    };
  },
  computed: {
    label() {
      const { permission } = this;
      const { permissionValue, name } = permission;
      return permissionValue ? name : `Select for ${name}`;
    },
  },
  methods: {
    async updatePermission() {
      this.loading = true;
      const { permission } = this;
      await this.$store.dispatch('UPDATE_PHOTO_PERMISSION', permission);
      this.loading = false;
    },
  },
  props: {
    permission: {
      required: true,
      type: Object,
    },
  },
};
</script>
